module.exports = __webpack_public_path__ + "static/media/eyes_left.59da37dc.svg";